import { render } from "./TheLeftSidebar.vue?vue&type=template&id=50d55c38&scoped=true"
import script from "./TheLeftSidebar.vue?vue&type=script&lang=js"
export * from "./TheLeftSidebar.vue?vue&type=script&lang=js"

import "./TheLeftSidebar.vue?vue&type=style&index=0&id=50d55c38&scoped=true&lang=scss"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d55c38"]])

export default __exports__